
import { CadastrarDietasDeactivateGuard } from './../guards/c-dietas-deactivate.guard';

import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';

import { DietasComponent } from './dietas.component';
import { DietasRotasModule } from './dietas.rotas.module';

@NgModule({
    imports: [
        CommonModule,
        RouterModule,
        DietasRotasModule
    ],
    exports: [],
    declarations: [DietasComponent],
    providers: [CadastrarDietasDeactivateGuard]
})

export class DietasModule { }


// WEBPACK FOOTER //
// ./src/app/dietas/dietas.module.ts